import { createStore as createReduxStore, combineReducers, applyMiddleware } from 'redux';
import { whereaboutsReducer as whereabouts, whereaboutsMiddleware } from '@rexlabs/whereabouts';
import thunkMiddleware from 'redux-thunk';
import { combineModels } from '../index';
export function createMockStore(entities) {
  return createReduxStore(combineReducers({
    whereabouts: whereabouts,
    // @ts-ignore
    entities: combineModels('entities', entities)
  }), // @ts-ignore
  applyMiddleware(whereaboutsMiddleware, thunkMiddleware));
}